export default "__VITE_ASSET__CKSCF6ao__"